// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v5/validate_new_phone_otp.proto

/* oxlint-disable */

/**
 * Request message for ValidateNewPhoneOtp (POST /v5/user/phone_number/validate_new_phone_otp).
 * Validates the OTP sent to the new (pending) phone number.
 */
export interface ApiValidateNewPhoneOtpRequest {
  /** The 6-digit OTP code sent to the pending phone number via SMS. */
  readonly newPhoneOtp: string;
}

/**
 * Response message for ValidateNewPhoneOtp.
 * Returns an empty body on success (200 OK).
 */
export interface ApiValidateNewPhoneOtpResponse {
}

export const ApiValidateNewPhoneOtpRequest: MessageFns<ApiValidateNewPhoneOtpRequest> = {
  fromJSON(object: any): ApiValidateNewPhoneOtpRequest {
    return { newPhoneOtp: isSet(object.new_phone_otp) ? globalThis.String(object.new_phone_otp) : "" };
  },

  toJSON(message: ApiValidateNewPhoneOtpRequest): unknown {
    const obj: any = {};
    if (message.newPhoneOtp !== undefined && message.newPhoneOtp !== null) {
      obj.new_phone_otp = message.newPhoneOtp;
    }
    return obj;
  },
};

export const ApiValidateNewPhoneOtpResponse: MessageFns<ApiValidateNewPhoneOtpResponse> = {
  fromJSON(_: any): ApiValidateNewPhoneOtpResponse {
    return {};
  },

  toJSON(_: ApiValidateNewPhoneOtpResponse): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
